import { EmailAdvisoryTemplate, EmailAdvisoryTemplateMap } from "@/proto/admin/all_pb";
import { ValueOf } from "@/utils/type-utils";

export interface IAdvisoryReason {
  label: string;
  value: ValueOf<EmailAdvisoryTemplateMap>;
}

export const disabledAdvisoryReasons: IAdvisoryReason[] = [
  {
    'label': 'Bank portal down',
    'value': EmailAdvisoryTemplate.BANK_PORTAL_DOWN,
  },
  {
    'label': 'Bank system maintenance',
    'value': EmailAdvisoryTemplate.BANK_SYSTEM_MAINTENANCE,
  },
  {
    'label': 'Bank intermittent connection',
    'value': EmailAdvisoryTemplate.BANK_INTERMITTENT_CONNECTION,
  },
  {
    'label': 'Bank scheduled maintenance',
    'value': EmailAdvisoryTemplate.BANK_SCHEDULED_MAINTENANCE,
  },
  {
    'label': 'Brankas system down',
    'value': EmailAdvisoryTemplate.BRANKAS_SYSTEM_DOWN,
  },
  {
    'label': 'Brankas scheduled maintenance',
    'value': EmailAdvisoryTemplate.BRANKAS_SCHEDULED_MAINTENANCE,
  },
  {
    'label': 'Payment rail down',
    'value': EmailAdvisoryTemplate.PAYMENT_RAIL_DOWN,
  },
  {
    'label': 'Others',
    'value': EmailAdvisoryTemplate.CUSTOM,
  },
];

export const enabledAdvisoryReasons: IAdvisoryReason[] = [
  {
    'label': 'Bank portal up',
    'value': EmailAdvisoryTemplate.BANK_PORTAL_UP,
  },
  {
    'label': 'Bank system maintenance finished',
    'value': EmailAdvisoryTemplate.BANK_SYSTEM_MAINTENANCE_FINISHED,
  },
  {
    'label': 'Bank intermittent connection restored',
    'value': EmailAdvisoryTemplate.BANK_INTERMITTENT_CONNECTION_RESTORED,
  },
  {
    'label': 'Bank scheduled maintenance finished',
    'value': EmailAdvisoryTemplate.BANK_SCHEDULED_MAINTENANCE_RESTORED,
  },
  {
    'label': 'Brankas system up',
    'value': EmailAdvisoryTemplate.BRANKAS_SYSTEM_UP,
  },
  {
    'label': 'Brankas scheduled maintenance finished',
    'value': EmailAdvisoryTemplate.BRANKAS_SCHEDULED_MAINTENANCE_RESTORED,
  },
  {
    'label': 'Payment rail up',
    'value': EmailAdvisoryTemplate.PAYMENT_RAIL_UP,
  },
  {
    'label': 'Others',
    'value': EmailAdvisoryTemplate.CUSTOM,
  },
];
